import { actionGenerator } from '../../utils/redux/actionGenerator';
import { INotificationError } from '../../types/notifications';
import { EErrorNotificationActionType } from './types';

export const removeErrorNotification = actionGenerator<EErrorNotificationActionType.Removed, INotificationError['id']>(
  EErrorNotificationActionType.Removed,
);
